import { useGlobalAlert } from "hooks/useAlert";
import { ActionFunctionArgs, redirect } from "react-router-dom";
import { api } from "services/api.service";
import { isAxiosError } from "utils/helpers";
import { withAuth } from "routes/utils/withAuth";

export const loader = withAuth(async () => {
  const activeDeviceId = localStorage.getItem("activeDeviceId");
  if (!activeDeviceId) {
    useGlobalAlert.alertError("A webcam is required to capture photos. Please select a video device.");
    return redirect("../../scan");
  }
  return { activeDeviceId };
});

export async function action({ params }: ActionFunctionArgs) {
  try {
    await api.post(`/inventories/${params.inventoryId}/ai_identify_inventory_images`);
    return redirect("../review");
  } catch (error: unknown) {
    if (isAxiosError(error)) useGlobalAlert.alertError(`Error while analyzing images: ${error.response?.data.message}`);
    return null;
  }
}
